<template>
  <div >
    <a-spin :spinning="loading">
    <div class="row">
      <div class="col-6">
        <h5 class="mb-3">
          Final Result settings for class: {{ selectedClass ?  selectedClass.name : null }}
        </h5>
      </div>
      <div class="col-6 text-md-right">
        <a-button
          type="primary"
          icon="file-protect"
          @click="handleDeclare"
          size="small"
          :disabled="!settingsExists"
        >
          {{ getDeclaredText() }}
        </a-button>
<!--        <a-button
          type="primary"
          icon="file-protect"
          style="margin-left:5px"
          @click="handleUnDeclare"
          size="small"
          :disabled="this.declareStat !== 0 ? false : true"
        >
          Reset Exam&lt;!&ndash; {{ getDeclaredText() }} &ndash;&gt;
        </a-button>-->
        <a-button
          type="primary"
          icon="eye"
          size="small"
          style="margin-left:5px"
          @click="handleViewFinalReports"
          :disabled="this.declareStat === 1 ? false : true"
        >
          Final Report
        </a-button>
      </div>
    </div>
    <a-form class="mb-4" :form="form">
      <a-form-item label="Select Section">
        <a-select
          placeholder="All Sections"
          v-decorator="[
                  'section',
                  {
                    rules: [
                      { required: false, message: 'Please select an option!!' }
                    ],
                    initialValue: undefined
                  }
                ]"
          @change="handleSectionSelect"
          style="width:200px"
        >
          <a-select-option :key="undefined" :value="undefined">
                All Section
              </a-select-option>
          <a-select-option
            v-for="sec in sections"
            :key="sec.id"
            :value="sec.id"
          >{{ sec.name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <div v-if="!sectionId">
        <span class="text-danger text-center"><b>Same settings will be saved for all the sections</b></span>
      </div>
      <div class="mb-3" v-if="this.schoolExams.length !== 0">
        <!-- Exam -->
        <a-form-item label="School Exams">
          <ul id="navlist">
            <li v-for="(module_data, index) in schoolExams" :key="index">
              <input
                type="checkbox"
                :id="module_data.name"
                :checked="checked"
                :value="module_data.id"
                v-model="examsSelected"
                @change="getSlNo($event, index)"
              />
              <label>{{ module_data.name }}</label>
              <span class="text-danger"
              ><b> &nbsp;{{ serialNo[index] }}</b></span
              >
            </li>
          </ul>
        </a-form-item>
      </div>
      <div class="mb-3" v-else>
        <p class="text-muted mt-2 mb-1">School Exams</p>
        <span class="text-danger"><b>No exams (or common exams) found !!</b></span>
      </div>
      <p class="text-muted mt-2 mb-1">Setup Ranking and Promotion Details</p>
      <a-divider />
      <div class="row">
        <div class="col-md-4">
          <a-form-item label="%score to give rankings upto">
            <a-input-number
              placeholder=""
              v-decorator="[
                  'final_exam_ranking_pc',
                  {
                    rules: [{ required: false, message: 'Required' }],
                    initialValue: rankPc
                  }
                ]"
              :min="0"
              :max="100"
              :disabled="false"
              style="width: 100%"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item label="Maximum ranks allowed">
            <a-input-number
              placeholder=""
              v-decorator="[
                  `final_exam_max_rank`,
                  {
                    rules: [{ required: false, message: 'Required' }],
                    initialValue: rankMax
                  }
                ]"
              :min="0"
              :max="200"
              :disabled="false"
              style="width: 100%"
            />
          </a-form-item>
        </div>
        <div class="col-md-4 text-md-right" style="padding-top:25px">
          <a-button
            key="submit"
            type="primary"
            icon="save"
            @click="handleSubmit"
          >
            Save Setting
          </a-button>
        </div>
      </div>
    </a-form>
    </a-spin>
  </div>
</template>
<script>
export default {
  name: 'FinalResultSettingForm',
  components: {
  },
  props: {
    settingData: Array,
    session: Number,
    selectedClass: {
      type: Object,
      default: () => {},
    },
  },
  activated: function() {
    this.getClassSections()
    this.getClassCommonExams()
  },
  mounted: function() {
    this.getClassSections()
    this.getClassCommonExams()
  },
  /* mounted: function() {
    this.getClassExams()
    this.getClassSections()
    // this.getFinalResultSetting()
    this.getCountNo()
    console.log('this.settingData')
    console.log(this.settingData)
    if (this.settingData.final_results_settings.length !== 0) {
      this.finalSettings = this.settingData.final_results_settings
    } else {
      this.finalSettings = []
    }
  }, */
  data: function() {
    return {
      form: this.$form.createForm(this),
      hover: false,
      loading: false,
      sections: [],
      classId: this.selectedClass ? this.selectedClass.id : null,
      schoolExams: [],
      sectionId: null,
      serialNo: [],
      count: 0,
      checked: true,
      examsSelected: [],
      declareStat: 2,
      rankPc: null,
      rankMax: null,
      selectedSetting: null,
    }
  },
  watch: {
  },
  computed: {
    settingsExists: function() {
      console.log(this.settingData.length)
      if (this.settingData && this.settingData.length !== 0) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    getClassSections() {
      this.loading = true
      this.$http
        .get('/api/section/class/' + this.classId, {
          params: {
            session_id: this.session,
          },
        })
        .then(({ data }) => {
          // this.loading = false
          this.sections = data.data
          this.loading = false
        })
    },

    handleSectionSelect(sectionId) {
      this.sectionId = sectionId
      this.getClassCommonExams()
      this.getSettingForSection(sectionId)
      this.mapSelectedSettingsToFields()
    },
    getSettingForSection(sectionId) {
      this.selectedSetting = this.settingData.filter((setting) => setting.section_id === sectionId)[0]
    },
    mapSelectedSettingsToFields() {
      if (this.selectedSetting) {
        this.selectedSetting.class_final_report_exams.forEach(
          (value, index) => {
            this.examsSelected.push(value.exam_id)
          }
        )
        this.rankPc = this.selectedSetting.final_exam_ranking_pc
        this.rankMax = this.selectedSetting.final_exam_max_rank
      } else {
        this.rankPc = null
        this.rankMax = null
      }
      this.form.setFieldsValue({
        final_exam_ranking_pc: this.rankPc,
        final_exam_max_rank: this.rankMax,
      })
    },
    getClassCommonExams() {
      this.loading = true
      this.examsSelected = []
      this.schoolExams = []
      this.$http
        .get(`/api/class_common_exams`, {
          params: {
            session_id: this.session,
            class_id: this.classId,
            section_id: this.sectionId,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.schoolExams = data.data
        })
      this.getCountNo()
    },
    getCountNo() {
      // alert(this.examsSelected.length)
      if (this.examsSelected.length > 0) {
        this.count = this.examsSelected.length
      }
    },
    getSlNo(e, index) {
      // alert(e.target.checked)
      if (e.target.checked === true) {
        this.serialNo[index] = this.count + 1
        this.count = this.count + 1
        this.serialNo.splice(index, 1, this.count)
      }
      if (e.target.checked === false) {
        this.removeSlData(this.count, index)
      }
    },
    removeSlData(data, key) {
      var current = this.serialNo[key]
      this.serialNo.forEach((item, index) => {
        if (this.serialNo[key] === item) {
          this.serialNo.splice(key, 1, null)
          if (this.count > 0) {
            this.count = this.count - 1
          }
        } else {
          if (current !== null) {
            if (item > current && this.serialNo[key] !== item + 1) {
              this.serialNo.splice(index, 1, item - 1)
            }
          }
        }
      })
    },
    handleUnDeclare() {
      this.$confirm({
        title: 'Are you sure?',
        content: h => (
          <div>
            <p class="mb-0">
              Click OK to reset the final exam for the selected class!
            </p>
          </div>
        ),
        onOk: () => {
          this.loading = true
          this.$http
            // .post("/api/declare_final_result/" + this.classId, {
            .post('/api/undeclare_final_result/' + this.classId, {
              params: {
                session_id: this.session,
              },
            })
            .then(({ data }) => {
              this.declareStat = 1
              this.loading = false
              this.$notification['info']({
                message: 'Final Result undeclared successfully!',
                // description: `Decleration of final results for the selected class has been started successfully! You will be notified once completed`,
              })
              // this.getFinalResultSetting()
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
      })
    },
    handleDeclare: function () {
      this.$confirm({
        title: 'Are you sure?',
        content: h => (
          <div>
            <p class="mb-0">
              Click OK to declare the final exam for the selected class!!
            </p>
          </div>
        ),
        onOk: () => {
          this.loading = true
          this.$http
            // .post("/api/declare_final_result/" + this.classId, {
            .post('/api/declare_final_result', {
              session_id: this.session,
              class_id: this.classId,
            })
            .then(({ data }) => {
              // this.getFinalResultSetting()
              // this.commonSetting.is_declared = 2;
              this.declareStat = 1
              this.loading = false
              this.$notification['info']({
                message: 'Final Result Process Initiated!',
                description: `Process for the evaluation of final results for the selected class/section has been started successfully! You will be notified once completed`,
                duration: 0,
              })
              // this.getFinalResultSetting()
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
      })
    },
    handleViewFinalReports() {
      /* this.$router.push({
        name: 'finalResultReport',
        params: {
          classId: this.getClassId,
          className: this.settingData.name,
          sessionId: this.session,
        },
      }) */
    },
    getDeclaredText: function () {
      if (this.declareStat !== 2) {
        if (this.declareStat === 1) {
          return 'Declared'
        } else if (this.declareStat === 0) {
          return 'Delcare Final'
        }
        // else {
        //   return 'Processing'
        // }
      } else {
        return 'Declare Final'
      }
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to save?`,
            content: `Click on the OK button to save final result settings!`,
            onOk: () => {
              this.loading = true
              this.$http
                .post('/api/finalresultsetting', {
                  class_id: this.classId,
                  section_id: this.sectionId,
                  final_exam_ranking_pc: values.final_exam_ranking_pc,
                  final_exam_max_rank: values.final_exam_max_rank,
                  final_exam_consider_failed_subject:
                  values.final_exam_consider_failed_subject,
                  exams: this.examsSelected,
                  // is_declared: 0
                })
                .then(({ data }) => {
                  this.$emit('savedFinalSetting')
                  // this.finalSettings = this.settingData.final_results_settings
                  //  this.getFinalResultSetting()
                  // this.finalSettings = this.settingData.final_results_settings
                  // this.finalSettings = data.data

                  // this.showsection = false
                  // this.getFinalResultSetting()
                  // this.settingId = data.data.id
                  // if (data.data.is_declared === 0) {
                  //   this.declareStat = data.data.is_declared
                  // }
                  // this.$emit('saved')
                  this.loading = false
                  this.$notification['success']({
                    message: 'Saved successfully',
                    description: `Final result settings saved successfully!`,
                  })
                  // this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
  },
}
</script>
<style>
#navlist li {
  display: inline;
  list-style-type: none;
  padding-right: 20px;
}
input[type="checkbox"] {
  transform: scale(1.3);
  margin-right: 10px;
}
</style>
